import { render, staticRenderFns } from "./ModalVerHistorico.vue?vue&type=template&id=22f1873b&scoped=true&"
import script from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
export * from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerHistorico.vue?vue&type=style&index=0&id=22f1873b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1873b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('22f1873b', component.options)
    } else {
      api.reload('22f1873b', component.options)
    }
    module.hot.accept("./ModalVerHistorico.vue?vue&type=template&id=22f1873b&scoped=true&", function () {
      api.rerender('22f1873b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedores/ModalVerHistorico.vue"
export default component.exports